import { W as WuiMenuPane$1, d as defineCustomElement$1 } from './p-2MYQ9zL1.js';

const WuiMenuPane = WuiMenuPane$1;
const defineCustomElement = defineCustomElement$1;

export { WuiMenuPane, defineCustomElement };
